import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import QuoteForm from '../components/QuoteForm';
import { services } from '../data/siteData';
import './Inner.css';

export function GetQuote() {
  const [params] = useSearchParams();
  const serviceParam = params.get('service') || '';

  return (
    <div>
      <section className="page-hero" style={{ textAlign: 'center' }}>
        <div className="ph-orb ph-orb-1" />
        <div className="ph-orb ph-orb-2" />
        <div className="container page-hero-inner">
          <div className="badge"><div className="badge-dot">✦</div>Let's build</div>
          <h1 className="ph-title">
            Get a <span className="grad-text">free quote</span>
          </h1>
          <p className="ph-sub">
            Tell us what you're building. We respond within 24 hours with a plan and honest pricing.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="gq-wrap">
            {/* Left: trust signals */}
            <div className="gq-left">
              <div className="gq-checks">
                {[
                  'Free 30-min discovery call',
                  'Detailed proposal in 48 hrs',
                  'Fixed-price or sprint-based',
                  '30-day post-launch support',
                  'No lock-in contracts',
                ].map(c => (
                  <div key={c} className="gq-check">
                    <div className="gq-check-icon">✓</div>
                    {c}
                  </div>
                ))}
              </div>
              <div className="gq-services">
                <p className="gq-services-label">We specialise in:</p>
                {services.map(s => (
                  <Link to={`/services/${s.id}`} key={s.id} className="gq-service-row">
                    <span className="gqs-icon" style={{ background: s.color }}>{s.icon}</span>
                    <div>
                      <div className="gqs-title">{s.title}</div>
                      <div className="gqs-meta">From {s.startingAt} · {s.timeline}</div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>

            {/* Right: form */}
            <div className="gq-form-wrap">
              <div className="gq-form-card">
                <h2>Project details</h2>
                <QuoteForm prefill={{ service: serviceParam }} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
